export enum ConfigType {
  /**
   * å­¦å
   */
  STUDENT = <any>'STUDENT',
  /**
   * ä¸»è®²äºº
   */
  SPEAKER = <any>'SPEAKER'
}
